import { makeStyles } from '@material-ui/core/styles';
// Import { DIMENSIONS } from '../../styles/constants';

export const useStyles = makeStyles(theme => ({
	rootContainer: {
		// MinHeight: DIMENSIONS.SEARCH_HEIGHT,
	},
	searchIcon: {
		color: theme.palette.text.secondary
	}
}));
